export default __webpack_public_path__ + "static/media/640_business06-jp-mobile.8b224e67.png";